import React, { useEffect } from 'react';

import { COGNITO_CLIENT_ID, COGNITO_DOMAIN, COGNITO_LOGOUT_URI } from '../../config';
import { clearAuthStorage } from '../../utils/authStorage';
import { AuthShell } from '../../components/AuthShell';

export const NoAccessPage: React.FC = () => {
  const userEmail = localStorage.getItem('userEmail') || '';

  const handleLogout = () => {
    clearAuthStorage();

    if (COGNITO_DOMAIN) {
      const logoutUrl =
        `https://${COGNITO_DOMAIN}/logout?` +
        `client_id=${encodeURIComponent(COGNITO_CLIENT_ID)}&` +
        `logout_uri=${encodeURIComponent(COGNITO_LOGOUT_URI)}`;
      window.location.href = logoutUrl;
      return;
    }

    window.location.href = '/login';
  };

  useEffect(() => {
    const t = window.setTimeout(() => {
      if (confirm('Your session has been idle. Would you like to stay signed in?')) {
        location.reload();
      } else {
        handleLogout();
      }
    }, 5 * 60 * 1000);

    return () => window.clearTimeout(t);
  }, []);

  return (
    <AuthShell maxWidth={550}>
      <div className="text-center">
        <span className="auth-brand-mark" style={{ width: '4rem', height: '4rem', fontSize: '1.75rem', margin: '0 auto 1.25rem' }}>
          <i className="ri-lock-2-line"></i>
        </span>

        <h3 style={{ fontSize: 'var(--np-text-xl)', fontWeight: 700, color: 'var(--bs-heading-color)', margin: '0 0 0.75rem' }}>Access required</h3>
        <p className="np-sub mb-4">
          Your account has been authenticated, but you haven't been added to any organization yet.
        </p>
      </div>

      <div className="np-banner np-tone-info mb-4" style={{ display: 'block', textAlign: 'left' }}>
        <strong>What does this mean?</strong>
        <p className="mb-0 mt-1">
          To access Mercell Nimbus, you need to be invited by an organization administrator. Your email address (
          <strong>{userEmail}</strong>) is registered with AWS Cognito, but it hasn't been associated with any
          organization in our system yet.
        </p>
      </div>

      <div className="np-row-card mb-4">
        <p className="fw-semibold mb-2" style={{ color: 'var(--bs-heading-color)' }}>
          <i className="ri-question-line me-2"></i>
          What should I do?
        </p>
        <ol className="mb-0 ps-3 np-sub">
          <li className="mb-2">Contact your organization administrator</li>
          <li className="mb-2">Ask them to send you an invitation to join their organization</li>
          <li className="mb-2">Once invited, you'll receive an email with an invitation link</li>
          <li>Click the link and you'll gain access to the platform</li>
        </ol>
      </div>

      <div className="text-center">
        <button onClick={handleLogout} className="np-btn np-btn-ghost">
          <i className="ri-logout-box-line"></i>
          Sign Out
        </button>
      </div>

      <p className="np-sub text-center mt-4 mb-0">
        Need help? Contact your organisation's administrator to request an invitation.
      </p>
    </AuthShell>
  );
};
